import type { Course, AppSettings, GPACalculationResult } from '@gpa-scales/shared-types';
import { calculateAllGPA } from './gpaCalculations';
import { computeContributions } from './courseContribution';
import { computeTermBreakdown } from './termBreakdown';
import { computeHonorsCapStatus } from './honorsEligibility';
import { validateAll } from './validation';
import { AGSubject, GradeLevel } from '@gpa-scales/shared-types';

export { applyRounding } from './rounding';
export { letterToGradePoints, percentageToLetter, resolveGradePoints } from './gradeConversion';
export { isHonorsEligible, computeHonorsCapStatus } from './honorsEligibility';
export { unweightedGPA, ucCappedGPA, ucUncappedGPA, ucUnweightedGPA, commonAppGPA, calculateAllGPA } from './gpaCalculations';
export { computeContributions } from './courseContribution';
export { computeTermBreakdown } from './termBreakdown';
export { validateAll } from './validation';
export { simulateFutureGrades, reverseEngineerTargetGPA, modelCourseSwap, GRADE_ORDER } from './scenarioModeling';
export {
  LETTER_GRADE_POINTS_PLUS_MINUS,
  LETTER_GRADE_POINTS_NO_PLUS_MINUS,
  PERCENTAGE_TO_LETTER_THRESHOLDS,
  IB_SCALE_MAPPING,
  ECTS_SCALE_MAPPING,
} from '../data/gradePointMappings';

function getUCEligibleCourses(courses: Course[]): Course[] {
  return courses.filter(
    (c) =>
      c.agSubject !== AGSubject.None &&
      (c.gradeLevel === GradeLevel.Sophomore || c.gradeLevel === GradeLevel.Junior)
  );
}

export function calculateEverything(
  courses: Course[],
  settings: AppSettings
): GPACalculationResult {
  const ucEligible = getUCEligibleCourses(courses);

  return {
    variants: calculateAllGPA(courses, settings),
    contributions: computeContributions(courses, settings),
    breakdown: computeTermBreakdown(courses, settings),
    honorsCap: computeHonorsCapStatus(courses, settings, ucEligible),
    validationIssues: validateAll(courses, settings),
    calculatedAt: new Date().toISOString(),
  };
}
